<div class="widget-container" #chartDiv>
    <app-dynamic-bar-chart
    [headerConfig]="this.item.config.widget_header_config"
    style="width: 100%;"
    [config]="config"
    [heading]="heading"
    [data]="data"
    [item]="item"
    [pageKey]="pageKey"
    [error_name]="error_name"
    (barClicked)="onBarClicked($event)"
    >
    </app-dynamic-bar-chart>
</div>
